var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-attention"},[_c('p',[_vm._v("\n    会議室・ホールの予約および料金や空き状況・スケジュールにつきましては、施設に直接お問い合わせください\n  ")]),_vm._v(" "),_c('kcs-btn',{attrs:{"url":_vm.detail.url,"external":true,"name":"施設へ問い合わせる"},nativeOn:{"click":function($event){return _vm.handleAnalyticsTrackEvent(
        'facility_detail',
        'click',
        'official_link',
        1
      )}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }